import config from '../../config';
import Component from '../Component';
import Lookup from './Lookup';
import React from 'react';

export default class QsectionLookup extends Component {

	api(q, page) {
		const client = config.getApiClient;
		return client.call('qsection.lookup', {q: q, page: page});
	}

	render() {
		return <Lookup  query={(q, page) => this.api(q, page)} {...this.props} />
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/QsectionLookup.js